import { render } from "./InterestAndComment.vue?vue&type=template&id=a1e2047a&scoped=true"
import script from "./InterestAndComment.vue?vue&type=script&lang=js"
export * from "./InterestAndComment.vue?vue&type=script&lang=js"

import "./InterestAndComment.vue?vue&type=style&index=0&id=a1e2047a&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e2047a"]])